import React from 'react';
import { Box, Grid, Link } from '@mui/material';
// import TwitterIcon from '@mui/icons-material/Twitter';
import heroImage from '../../../Assets/Images/simsola_logo.png';
import linkedinIcon from '../../../Assets/Images/linkedinIcon.svg';
import './Footer.css';
import { Link as RouterLink } from 'react-router-dom';
import { useBookDemo } from '../../../Utils/ContextHelper/BookDemoContext';
import { trackCta } from '../../../Utils/analytics';
import { ASSESSMENT_BUSINESS_PATH, ASSESSMENT_CANDIDATE_PATH } from '../../../Utils/urls';
import { FooterAward } from '../Award/AwardPlacements';

const Footer = () => {
	const { openBookDemo } = useBookDemo();
	return (
		<Box className="container" sx={{ paddingTop: '57px', paddingBottom: '33px' }}>
			<Grid container display={'flex'} className="footer-grid" justifyContent={'center'}>
				<Grid item xs={12} md={3} className="footer-item">
					<Box>
						<div className="footer-logo">
							<img src={heroImage} alt="Simsola" width={206} height={37} />
						</div>
						<div
							className="footer-description"
							style={{
								fontFamily: 'DM Mono'
							}}
						>
							The AI platform measuring how people collaborate, influence, and navigate challenges.
						</div>
						<FooterAward />
					</Box>
				</Grid>

				<Grid item xs={12} md={6} className="links-contacts">
					<Grid item xs={12} md={3} className="footer-item">
						<div className="footer-section">
							<div className="footer-heading">Product</div>
							<div>
								<RouterLink
									to={ASSESSMENT_BUSINESS_PATH}
									className="footer-link"
									onClick={() =>
										trackCta('product page clicked', {
											cta_label: 'Assessment Service for Businesses',
											product: 'assessment',
											app_surface: 'business',
											location: 'footer'
										})
									}
								>
									Assessment Service for Businesses
								</RouterLink>
							</div>
							<div>
								<RouterLink
									to={ASSESSMENT_CANDIDATE_PATH}
									className="footer-link"
									onClick={() =>
										trackCta('product page clicked', {
											cta_label: 'Assessment Service for Candidates',
											product: 'assessment',
											app_surface: 'candidate',
											location: 'footer'
										})
									}
								>
									Assessment Service for Candidates
								</RouterLink>
							</div>
							<div>
								<RouterLink to="/product/6d-assessment" className="footer-link">
									MyCoach (L&amp;D)
								</RouterLink>
							</div>
						</div>
					</Grid>

					<Grid item xs={12} md={3} className="footer-item">
						<div className="footer-section">
							<div className="footer-heading">Company</div>
							{/* <div>
								<RouterLink to="/product/6d-assessment" className="footer-link">
									Product
								</RouterLink>
							</div> */}
							<div>
								<RouterLink to="/vision" className="footer-link">
									Vision
								</RouterLink>
							</div>
							<div>
								<RouterLink to="/about-us" className="footer-link">
									About us
								</RouterLink>
							</div>
						</div>
					</Grid>

					<Grid item xs={12} md={3} className="footer-item">
						<div className="footer-section">
							<div className="footer-heading">Resources</div>
							<div>	<RouterLink to="/resources" className="footer-link">
								Insights
							</RouterLink>
							</div>
							<div>
								<RouterLink to="/results" className="footer-link">
									Results
								</RouterLink>
							</div>
							<div>
								<div
									className="footer-link"
									onClick={() => openBookDemo({ cta_label: 'Contact us', location: 'footer', event: 'contact clicked' })}
									onKeyDown={e => {
										if (e.key === 'Enter' || e.key === ' ') {
											e.preventDefault();
											openBookDemo({ cta_label: 'Contact us', location: 'footer', event: 'contact clicked' });
										}
									}}
									role="button"
									tabIndex={0}
								>
									Contact Us
								</div>
							</div>
							<div>
								<RouterLink
									to="/frequently-asked-questions"
									className="footer-link"
									onClick={() => {
										window.requestAnimationFrame(() => {
											window.scrollTo({ top: 0, behavior: 'smooth' });
										});
									}}
								>
									FAQ
								</RouterLink>
							</div>
						</div>
					</Grid>

					<Grid item xs={12} md={3} className="footer-item">
						<div className="footer-section">
							<div className="footer-heading">Contacts</div>
							<div>
								<a href="mailto:service@simsola.ai" className="footer-link footer-contact-value">
									service@simsola.ai
								</a>
							</div>
						</div>
					</Grid>
				</Grid>

				<Grid item xs={12} md={3} className="footer-item social_blocks">
					<Box sx={{ mt: 2, display: 'flex', gap: '8px', justifyContent: 'end' }}>
						{/* <div className="footer-social-icon" >
							<img src={TwitterIcon} alt="loading" />
						</div>
						<div className="footer-social-icon" >
							<img src={LanguageIcon} alt="loading" />
						</div>
						<div className="footer-social-icon" >
							<img src={UpworkIcon} alt="loading" />
						</div>
						<div className="footer-social-icon" >
							<img src={SocialIcon} alt="loading" />
						</div> */}
						<a
							href="https://www.linkedin.com/company/simsola-ai/about/?viewAsMember=true"
							target="_blank"
							rel="noopener noreferrer"
							className="footer-social-icon"
						>
							<img src={linkedinIcon} alt="LinkedIn" />
						</a>
					</Box>
				</Grid>
			</Grid>
			<Grid container display={'flex'} flexDirection={'row-reverse'} className="footer-bottom">
				<Grid item xs={12} md={6} className="footer-legal-links">
					<Link
						href="/terms-of-use"
						target="_blank"
						rel="noopener noreferrer"
						underline="none"
						className="footer-legal-link"
					>
						Terms & Conditions
					</Link>
					<Link
						href="/privacy-policy"
						target="_blank"
						rel="noopener noreferrer"
						underline="none"
						className="footer-legal-link"
					>
						Privacy Policy
					</Link>
				</Grid>
				<Grid item xs={12} md={6} className="footer-copyright">
					© Simsola 2024-2026. All Rights Reserved
				</Grid>
			</Grid>
		</Box>
	);
};

export default Footer;
